export const CLASSIFICATION_MODELS = {
  bert: "mBERT", 
  bilstm: "Bi LSTM", 
  mlp: "MLP", 
  naivebayes: "Naive Bayes", 
  gradientboost: "Gradient Boost", 
  xgboost: "XG Boost"
 } as const

export const classificationConfig = {
  id: "classify",
  title: "Classification",
  endpoint: import.meta.env.VITE_API_ENDPOINT,
  input_text_min_length: 10
} as const